import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const RocketOutline = createIcon({
  displayName: 'RocketOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.94,11.06l-7.07,7.07"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.633,12.999l-3.463,-0.818c-0.381,-0.09 -0.515,-0.563 -0.239,-0.84l2.754,-2.754c0.185,-0.185 0.436,-0.291 0.699,-0.293l3.105,-0.027"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.879,8.975l0.808,-3.888c0.22,-1.058 -0.716,-1.994 -1.774,-1.774l-3.888,0.808c-1.145,0.238 -2.195,0.805 -3.021,1.632l-3.19,3.189c-1.217,1.217 -2.009,2.795 -2.259,4.498l-0.011,0.073c-0.158,1.087 0.206,2.184 0.982,2.961v0c0.776,0.776 1.874,1.14 2.961,0.981l0.073,-0.011c1.703,-0.249 3.281,-1.042 4.498,-2.259l3.189,-3.189c0.827,-0.826 1.394,-1.876 1.632,-3.021Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.4,4.714c2.311,1.576 4.31,3.575 5.886,5.886"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11,17.367l0.818,3.463c0.09,0.381 0.563,0.515 0.84,0.239l2.754,-2.754c0.185,-0.185 0.291,-0.436 0.293,-0.699l0.027,-3.105"
        ></path>
      </g>
    </>
  ),
})

const RocketTwoTone = createIcon({
  displayName: 'RocketTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none" color="twoToneStrokeColor">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12.94,11.06l-7.07,7.07"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.633,12.999l-3.463,-0.818c-0.381,-0.09 -0.515,-0.563 -0.239,-0.84l2.754,-2.754c0.185,-0.185 0.436,-0.291 0.699,-0.293l3.105,-0.027"
        ></path>
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.879,8.975l0.808,-3.888c0.22,-1.058 -0.716,-1.994 -1.774,-1.774l-3.888,0.808c-1.145,0.238 -2.195,0.805 -3.021,1.632l-3.19,3.189c-1.217,1.217 -2.009,2.795 -2.259,4.498l-0.011,0.073c-0.158,1.087 0.206,2.184 0.982,2.961v0c0.776,0.776 1.874,1.14 2.961,0.981l0.073,-0.011c1.703,-0.249 3.281,-1.042 4.498,-2.259l3.189,-3.189c0.827,-0.826 1.394,-1.876 1.632,-3.021Z"
        ></Box>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.4,4.714c2.311,1.576 4.31,3.575 5.886,5.886"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M11,17.367l0.818,3.463c0.09,0.381 0.563,0.515 0.84,0.239l2.754,-2.754c0.185,-0.185 0.291,-0.436 0.293,-0.699l0.027,-3.105"
        ></path>
      </Box>
    </>
  ),
})

const Rocket: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={RocketTwoTone} {...props} />
  default:
    return <CustomIcon as={RocketOutline} {...props} />
  }
}

export default memo(Rocket)
